import React, { useContext } from "react";
import { Container, Typography, Link, Box, Divider } from "@mui/material";
import "./Footer.css";
import Logo from "../../assets/logo.svg";
import LogoAr from "../../assets/logo_ar.svg";
import LogoDark from "../../assets/logo_dark.svg";
import LogoDarkAr from "../../assets/logo_dark_ar.svg";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import DolfLogo from "../../assets/images/partenars/dolf_logo.png";
import DolfLogoDark from "../../assets/images/partenars/dolf_logo_dark.png";
import NCLLogo from "../../assets/images/partenars/nlc_logo.png";
import NCLLogoDark from "../../assets/images/partenars/nlc_logo_dark.png";
import { t } from "../../utils/i18n";
import { useSelector } from "react-redux";
import { ThemeContext } from "../../ThemeContext";

const Footer = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const { mode } = useContext(ThemeContext); 

  return (
    <Box
      className="footer"
      sx={{
        bgcolor: (theme) => theme.palette.background.footer,
      }}
    >
      <Container maxWidth="100%" sx={{ px: " 0px !important" }}>
        <Box className="footer-content" px={5}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* Logo & Contact */}
            <div className="logo-section">
              <div className="logo">
                <img src={ mode==="light" ? lang==="ar" ? LogoAr : Logo : lang==="ar" ? LogoDarkAr : LogoDark } alt="Naahel Cyber Logo" width={120} />
              </div>
              <Typography variant="h5" letterSpacing={1.5} dir="ltr" sx={{ textAlign : lang === "ar" ? "right" : "left"}}>
                +966-548 16 1616
              </Typography>
              <div className="social-icons">
                <Link href="#" className="social-icon">
                  <MailOutlineIcon sx={{ fontSize: 18, color:"white" }}/>
                </Link>
                <Link href="#" className="social-icon">
                  <InstagramIcon sx={{ fontSize: 18, color:"white" }}/>
                </Link>
                <Link href="#" className="social-icon">
                  <XIcon sx={{ fontSize: 18, color:"white" }}/>
                </Link>
                <Link href="#" className="social-icon">
                  <LinkedInIcon sx={{ fontSize: 18, color:"white" }}/>
                </Link>
              </div>
            </div>

            {/* Divider before About Section */}
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                mx: 3,
                height: "auto",
                borderColor: (theme) => theme.palette.background.footerDivider,
              }}
            />

            {/* About Naahel Cyber Links */}
            <div className="about-section">
              <Typography variant="h4" fontWeight={500}>
                {t(lang, "footer.about-naahelcyber")}
              </Typography>
              <ul className="links-list">
                <li>
                  <Link
                    onClick={() => {
                      const el = document.getElementById("pricing");
                      if (el)
                        el.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                    }}
                    sx={{
                      color: (theme) => theme.palette.text.primary,
                      cursor: "pointer",
                    }}
                  >
                    <Typography variant="h6" fontWeight={400}>
                      {t(lang, "footer.pricing-planes")}
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => {
                      const el = document.getElementById("faq");
                      if (el)
                        el.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                    }}
                    sx={{
                      color: (theme) => theme.palette.text.primary,
                      cursor: "pointer",
                    }}
                  >
                    <Typography variant="h6" fontWeight={400}>
                      {t(lang, "footer.news")}
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => {
                      const el = document.getElementById("reviews");
                      if (el)
                        el.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                    }}
                    sx={{
                      color: (theme) => theme.palette.text.primary,
                      cursor: "pointer",
                    }}
                  >
                    <Typography variant="h6" fontWeight={400}>
                      {t(lang, "footer.investors")}
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => {
                      const el = document.getElementById("faq");
                      if (el)
                        el.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                    }}
                    sx={{
                      color: (theme) => theme.palette.text.primary,
                      cursor: "pointer",
                    }}
                  >
                    <Typography variant="h6" fontWeight={400}>
                      {t(lang, "footer.faq")}
                    </Typography>
                  </Link>
                </li>
                <li>
                  <Link
                    href="#"
                    sx={{
                      color: (theme) => theme.palette.text.primary,
                    }}
                  >
                    <Typography variant="h6" fontWeight={400}>
                      {t(lang, "footer.site-map")}
                    </Typography>
                  </Link>
                </li>
              </ul>
            </div>

            {/* Divider after About Section */}
            {/* <Divider
              orientation="vertical"
              flexItem
              sx={{
                mx: 3,
                height: "auto",
                borderColor: (theme) => theme.palette.background.footerDivider,
              }}
            /> */}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 8 }}>
            {/* Certifications */}
            <div className="certification-section">
              <Typography variant="h5" fontWeight={500} textAlign="center">
                {" "}
                {t(lang, "footer.certified")}
              </Typography>
              <div className="certification-logos">
                <img src={mode === "light" ? NCLLogo : NCLLogoDark} alt="National Learning Center" />
              </div>
            </div>

            {/* Developed By */}
            {/* <div className="developed-section">
              <Typography variant="h5" fontWeight={500}> {t(lang, "footer.developed")}</Typography>
              <div className="developed-logos">
                <img src={mode === "light" ? DolfLogo : DolfLogoDark} alt="SOLP Technologies"  />
              </div>
            </div> */}
          </Box>
        </Box>

        {/* Bottom Bar */}
        <Box
          className="footer-bottom"
          px={5}
          sx={{
            bgcolor: (theme) => theme.palette.background.footerBottom,
          }}
        >
          <Typography variant="h6" fontWeight={500}>
            {t(lang, "footer.copyright")}
          </Typography>
          <div className="legal-links">
            <Link
              href="#"
              className="legal-link"
              sx={{
                color: (theme) => theme.palette.background.globalButton,
              }}
            >
              <Typography variant="h6" fontWeight={500}>
                {t(lang, "footer.terms_conditions")}
              </Typography>
            </Link>
            <Link
              href="#"
              className="legal-link"
              sx={{
                color: (theme) => theme.palette.background.globalButton,
              }}
            >
              <Typography variant="h6" fontWeight={500}>
                {t(lang, "footer.privacy")}
              </Typography>
            </Link>
            <Link
              href="#"
              className="legal-link"
              sx={{
                color: (theme) => theme.palette.background.globalButton,
              }}
            >
              <Typography variant="h6" fontWeight={500}>
                {t(lang, "footer.accessibilies")}
              </Typography>
            </Link>
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
